import React, { useState } from 'react';
import { 
  AlertTriangle, Users, Clock, Calendar, CheckCircle, X, AlertCircle
} from 'lucide-react';
import { useAuth } from '../../../../context/AuthContext';

// Import tab components
import LongShiftsTab from './alertsReview/LongShiftsTab';
import UserReviewTab from './alertsReview/UserReviewTab';

const AlertsReview = () => {
  // State
  const [activeTab, setActiveTab] = useState('long-shifts');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { currentUser } = useAuth();

  // Tab configuration
  const tabs = [
    {
      id: 'long-shifts',
      name: 'Long Shifts',
      icon: <Clock className="w-4 h-4 mr-2" />,
      component: <LongShiftsTab setError={setError} setSuccess={setSuccess} />
    },
    {
      id: 'user-review',
      name: 'User Review',
      icon: <Users className="w-4 h-4 mr-2" />,
      component: <UserReviewTab setError={setError} setSuccess={setSuccess} />
    }
  ];

  return (
    <div className="space-y-6 overflow-hidden">
      
      {/* Tab Navigation */}
      <div className="bg-slate-800 border border-slate-700 rounded-lg overflow-hidden">
        <div className="flex flex-wrap border-b border-slate-700 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`py-3 px-4 text-sm font-medium whitespace-nowrap ${
                activeTab === tab.id
                  ? 'text-blue-400 border-b-2 border-blue-400'
                  : 'text-slate-400 hover:text-slate-300'
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              <div className="flex items-center">
                {tab.icon}
                {tab.name}
              </div>
            </button>
          ))}
        </div>
        
        {/* Tab Content */}
        <div className="p-6">
          {/* Success Message */}
          {success && (
            <div className="mb-6 bg-green-900/30 border border-green-800 text-green-300 px-4 py-3 rounded-md flex items-start">
              <CheckCircle className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" />
              <div>{success}</div>
              <button 
                onClick={() => setSuccess(null)} 
                className="ml-auto text-green-300 hover:text-green-100"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          )}
          
          {/* Error Message */}
          {error && (
            <div className="mb-6 bg-red-900/30 border border-red-800 text-red-300 px-4 py-3 rounded-md flex items-start">
              <AlertCircle className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" />
              <div>{error}</div>
              <button 
                onClick={() => setError(null)} 
                className="ml-auto text-red-300 hover:text-red-100"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          )}
          
          {/* Render active tab component */}
          {tabs.find(tab => tab.id === activeTab)?.component}
        </div>
      </div>
    </div>
  );
};

export default AlertsReview;